/** Event emitted when the checkbox's checked state changes. */
export class HxCheckboxChange {
  /** The source HxCheckbox of the event. */
  source: any; // Will be typed as HxCheckbox when component is defined

  /** The new checked value of the checkbox. */
  checked: boolean;

  constructor(source: any, checked: boolean) {
    this.source = source;
    this.checked = checked;
  }
}
